export class Series {
    constructor({
        id,
        title,
        subtitle,
        description,
        thumbnailUrl,
        templateId,
        additionalInfo,
        userAccess,
        episodes,
        isBlocked,
        createdAt,
        updatedAt
    }) {
        this.id = id;
        this.title = title;
        this.subtitle = subtitle;
        this.description = description;
        this.thumbnailUrl = thumbnailUrl;
        this.templateId = templateId;
        this.additionalInfo = additionalInfo;
        this.userAccess = userAccess || [];
        this.episodes = episodes || [];
        this.isBlocked = isBlocked;
        this.createdAt = createdAt ? new Date(createdAt) : null;
        this.updatedAt = updatedAt ? new Date(updatedAt) : null;
    }

    static fromAPI(apiData) {
        return new Series({
            id: apiData.serie_id,
            title: apiData.serie_title,
            subtitle: apiData.serie_subtitle,
            description: apiData.serie_description,
            thumbnailUrl: apiData.serie_thumbnail_url,
            templateId: apiData.serie_template_id,
            additionalInfo: apiData.serie_additional_info,
            userAccess: apiData.serie_access,
            episodes: apiData.serie_episodes || [],
            isBlocked: apiData.serie_is_blocked,
            createdAt: apiData.serie_created_at,
            updatedAt: apiData.serie_updated_at
        });
    }

    toAPI() {
        return {
            serie_id: this.id,
            serie_title: this.title,
            serie_subtitle: this.subtitle,
            serie_description: this.description,
            serie_thumbnail_url: this.thumbnailUrl,
            serie_template_id: this.templateId,
            serie_additional_info: this.additionalInfo,
            serie_access: this.userAccess,
            serie_episodes: this.episodes,
            serie_is_blocked: this.isBlocked
        };
    }
} 